import * as React from 'react';

import type {User} from 'nutshell-core/users/users-types';

import {CardWidgetWrapper} from '../../../core/card';
import {getCustomFieldAddOptions} from '../../../core-entity/util/widget-components';

type Props = {
    stagesetId: string | null | undefined;
    customFields: HTMLElement;
    customFieldsCount: number;
    onRenderLeadMarkup: () => void;
    user: User | null | undefined;
};

export function TopCustomFieldsWidgetOld(props: Props) {
    return (
        <CardWidgetWrapper
            widgetKey='leadTopCustomFields'
            isEmpty={props.customFieldsCount === 0}
            minExpandedHeight={120}
            rowsHavePadding={false}
            // @ts-expect-error
            addButtonProps={getCustomFieldAddOptions(props.user, props.stagesetId)}
        >
            <div
                ref={(ref) => {
                    if (ref && props.onRenderLeadMarkup) {
                        props.onRenderLeadMarkup();
                    }
                }}
                dangerouslySetInnerHTML={{
                    __html: props.customFields.outerHTML,
                }}
            />
        </CardWidgetWrapper>
    );
}
